import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { CheckboxGroup } from '../ui/CheckboxGroup';
import { FileUpload } from '../ui/FileUpload';
import { MascotPanel } from '../ui/MascotPanel';
export function Step6Legal() {
  const {
    data,
    updateData
  } = useIntake();
  const legalDocOptions = [{
    value: 'algemene_voorwaarden',
    label: 'Algemene Voorwaarden'
  }, {
    value: 'privacyverklaring',
    label: 'Privacyverklaring'
  }, {
    value: 'cookiebeleid',
    label: 'Cookiebeleid'
  }, {
    value: 'disclaimer',
    label: 'Disclaimer'
  }, {
    value: 'retourbeleid',
    label: 'Retourbeleid'
  }, {
    value: 'garantiebeleid',
    label: 'Garantiebeleid'
  }, {
    value: 'klachtenprocedure',
    label: 'Klachtenprocedure'
  }, {
    value: 'leveringsvoorwaarden',
    label: 'Leveringsvoorwaarden'
  }, {
    value: 'verwerkersovereenkomst',
    label: 'Verwerkersovereenkomst'
  }, {
    value: 'servicevoorwaarden',
    label: 'Servicevoorwaarden / SLA'
  }, {
    value: 'overig',
    label: 'Overige documenten'
  }];
  const handleDocUpload = (docValue: string, url: string) => {
    updateData({
      legalDocs: {
        ...data.legalDocs,
        [docValue]: {
          file: url,
          text: '',
          status: 'uploaded'
        }
      }
    });
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-503" data-mp="790osje2eejj">
      <MascotPanel message="Een website moet niet alleen mooi zijn, maar ook juridisch kloppen. Heeft u al documenten zoals algemene voorwaarden of een privacyverklaring?" data-id="element-504" data-mp="2nxeawi0lkyzt" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-505" data-mp="2j04lh2d7knbz">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-506" data-mp="2kd4f0xrw25dt">Juridische Zaken</h2>

        <div data-id="element-507" data-mp="2pd8vwowpl24k">
          <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-508" data-mp="2pbxq6jjpdkat">
            Zijn er juridische documenten die op de website moeten komen?
          </label>
          <RadioGroup columns={1} value={data.hasLegalDocs} onChange={val => updateData({
          hasLegalDocs: val
        })} options={[{
          value: 'yes',
          label: 'Ja, ik heb deze documenten al'
        }, {
          value: 'no',
          label: 'Nee, ik moet deze nog (laten) opstellen'
        }]} data-id="element-509" data-mp="2fejfz1odhrqy" />
        </div>

        <AnimatePresence data-id="element-510" data-mp="1iqdaydnjgxc5">
          {data.hasLegalDocs === 'yes' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 overflow-hidden pt-4 border-t border-gray-100" data-id="element-511" data-mp="1nnd8u1a8its6">
              <div data-id="element-512" data-mp="190eloiieulj9">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-513" data-mp="1942bb6kqinsp">
                  Welke documenten heeft u beschikbaar?
                </label>
                <CheckboxGroup columns={2} options={legalDocOptions} values={data.legalDocsList} onChange={vals => updateData({
              legalDocsList: vals
            })} data-id="element-514" data-mp="1i1utcihuc9js" />
              </div>

              {data.legalDocsList.length > 0 && <div className="space-y-6 mt-6" data-id="element-515" data-mp="20uglarpmnfz3">
                  <h3 className="font-semibold text-gray-900" data-id="element-516" data-mp="3v9dpb93g7x2t">
                    Upload uw documenten
                  </h3>
                  {data.legalDocsList.map(docValue => {
              const docLabel = legalDocOptions.find(o => o.value === docValue)?.label;
              return <div key={docValue} className="bg-gray-50 p-4 rounded-xl border border-gray-200" data-id="element-517" data-mp="cuuzhpvae9h4">
                        <FileUpload label={docLabel} accept=".pdf,.doc,.docx" uploadKey={`legal_${docValue}`} value={data.legalDocs[docValue]?.file} onChange={url => handleDocUpload(docValue, url)} data-id="element-518" data-mp="3h8t7og99s7aw" />
                      </div>;
            })}
                </div>}
            </motion.div>}

          {data.hasLegalDocs === 'no' && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-6 overflow-hidden pt-4 border-t border-gray-100" data-id="element-519" data-mp="1fn7c1nyc5ihp">
              <div data-id="element-520" data-mp="wv4p5uv3p5z0">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-521" data-mp="rynzgw896jjt">
                  Hoe wilt u dit aanpakken?
                </label>
                <RadioGroup columns={1} value={data.legalDocsApproach} onChange={val => updateData({
              legalDocsApproach: val
            })} options={[{
              value: 'noord',
              label: 'Noord Digital helpt mij hierbij',
              description: 'Wij zorgen voor juridisch correcte documenten'
            }, {
              value: 'advisor',
              label: 'Ik schakel zelf een juridisch adviseur in'
            }, {
              value: 'self',
              label: 'Ik stel ze zelf op'
            }]} data-id="element-522" data-mp="mztgnuaacuzp" />
              </div>

              <div data-id="element-523" data-mp="ydv8hr6z1zsq">
                <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-524" data-mp="ycaec2okkive">
                  Welke documenten heeft u nodig?
                </label>
                <CheckboxGroup columns={2} options={legalDocOptions} values={data.legalDocsNeeded} onChange={vals => updateData({
              legalDocsNeeded: vals
            })} data-id="element-525" data-mp="pcnala8db0z6" />
              </div>
            </motion.div>}
        </AnimatePresence>

        <div className="bg-gray-50 rounded-xl p-6 border border-gray-200" data-id="element-526" data-mp="2xl1wl7z88mqt">
          <h3 className="font-semibold text-gray-900 mb-4" data-id="element-527" data-mp="3blmcnwdrc4gm">
            Welke documenten zijn vaak nodig?
          </h3>
          <ul className="space-y-3 text-sm text-gray-700" data-id="element-528" data-mp="36mt0q8e4clik">
            <li className="flex items-start" data-id="element-529" data-mp="2iw5qhggqdjsu">
              <span className="text-[#007AFF] mr-2" data-id="element-530" data-mp="2ix8jbtxm5wbe">•</span>
              <span data-id="element-531" data-mp="2dydnnrejsd9v">
                <strong data-id="element-532" data-mp="2dyx5l84771nw">Privacyverklaring:</strong> Verplicht als u een
                contactformulier heeft of analytics gebruikt.
              </span>
            </li>
            <li className="flex items-start" data-id="element-533" data-mp="2nva0287khjjp">
              <span className="text-[#007AFF] mr-2" data-id="element-534" data-mp="2nuh0br70zub2">•</span>
              <span data-id="element-535" data-mp="205fnzsv2nz0i">
                <strong data-id="element-536" data-mp="204wff2rbamz5">Cookiebeleid:</strong> Verplicht bij gebruik van
                tracking cookies.
              </span>
            </li>
            <li className="flex items-start" data-id="element-537" data-mp="1v5a08nrxawnp">
              <span className="text-[#007AFF] mr-2" data-id="element-538" data-mp="19ourr72wyhzi">•</span>
              <span data-id="element-539" data-mp="1emwcrxjwgrdm">
                <strong data-id="element-540" data-mp="1em306fy9f7nk">Algemene Voorwaarden:</strong> Sterk aanbevolen voor uw
                dienstverlening.
              </span>
            </li>
            <li className="flex items-start" data-id="element-541" data-mp="1jko4aqgmubha">
              <span className="text-[#007AFF] mr-2" data-id="element-542" data-mp="1ollk4we66tfm">•</span>
              <span data-id="element-543" data-mp="1oizej2auao01">
                <strong data-id="element-544" data-mp="1smxax58s5kpe">Disclaimer:</strong> Beschermt u tegen aansprakelijkheid
                voor informatie op de website.
              </span>
            </li>
            <li className="flex items-start" data-id="element-545" data-mp="1xjxjpnx0l1k7">
              <span className="text-[#007AFF] mr-2" data-id="element-546" data-mp="22bxd0xikww7t">•</span>
              <span data-id="element-547" data-mp="22ejtjmng6m26">
                <strong data-id="element-548" data-mp="27bjytvch3ks8">Retourbeleid:</strong> Verplicht voor webshops
                (herroepingsrecht).
              </span>
            </li>
            <li className="flex items-start" data-id="element-549" data-mp="2cbxz2r7u1qfp">
              <span className="text-[#007AFF] mr-2" data-id="element-550" data-mp="2c8tq7gjfa6ip">•</span>
              <span data-id="element-551" data-mp="2gd1bt4ul36cp">
                <strong data-id="element-552" data-mp="2ga5gzpe18xsh">Garantiebeleid:</strong> Aanbevolen als u producten
                verkoopt.
              </span>
            </li>
            <li className="flex items-start" data-id="element-553" data-mp="mrsr21oxemc">
              <span className="text-[#007AFF] mr-2" data-id="element-554" data-mp="lq7k4qynbqw">•</span>
              <span data-id="element-555" data-mp="3rt2pwn3kxv8e">
                <strong data-id="element-556" data-mp="3rudpsbtwmiu8">Klachtenprocedure:</strong> Verplicht voor bepaalde
                branches (bijv. zorg, financieel).
              </span>
            </li>
            <li className="flex items-start" data-id="element-557" data-mp="ocm39cyjer3f">
              <span className="text-[#007AFF] mr-2" data-id="element-558" data-mp="occd9pdhsjxq">•</span>
              <span data-id="element-559" data-mp="jd97u3tlobp8">
                <strong data-id="element-560" data-mp="jeu2dtfwzun3">Leveringsvoorwaarden:</strong> Belangrijk bij fysieke
                producten of diensten met levertijden.
              </span>
            </li>
            <li className="flex items-start" data-id="element-561" data-mp="9o93e4wbwo3n">
              <span className="text-[#007AFF] mr-2" data-id="element-562" data-mp="9ng5zuj9fay6">•</span>
              <span data-id="element-563" data-mp="173vfvv3ltvz8">
                <strong data-id="element-564" data-mp="174eup2xyk491">Verwerkersovereenkomst:</strong> Nodig als u
                persoonsgegevens deelt met derden.
              </span>
            </li>
            <li className="flex items-start" data-id="element-565" data-mp="s9z232x02z8n">
              <span className="text-[#007AFF] mr-2" data-id="element-566" data-mp="saqk1axocygg">•</span>
              <span data-id="element-567" data-mp="nb46f0dxpg74">
                <strong data-id="element-568" data-mp="nbnt0uej4srh">Servicevoorwaarden / SLA:</strong> Voor bedrijven die
                doorlopende diensten leveren.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </motion.div>;
}